/* eslint-disable no-console */
import React, { useEffect, useState } from "react";
import { CardBody, Card, Modal, ModalBody, UncontrolledTooltip } from "reactstrap";
import DataTable from "react-data-table-component";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import useFetcher from "../../hooks/useFetcher";
import { getOrdenesDeVentaById, updateOrdenDeVenta } from "../../services/ordenDeVentaServices";
import { BlurSpinner } from "../BlurSpinner";
import { ModalButton, SpinnerButtonPrimary } from "../../ui/buttons";
import { getNotasDePedidoCategory } from "../../services/notasDePedidoServices";
import { getEstadoByValue } from "../CandidatosNP/utils";
import { addTransparency } from "../../pages/NotasDePedido/utils";
import { InvoiceButton } from "./styles";
import { formatNumberWithPointsAndComma } from "../OrdenDeVentaForm/utils";

const getColorByStatus = (estado) => {
  switch (estado) {
    case 1:
      return "#808080"; // Gris
    case 2:
      return "#e5c53c"; // Amarillo
    case 3:
      return "#008000"; // Verde
    case 4 || 5:
      return "#FF0000"; // Rojo
    default:
      return "#293134";
  }
};

const OrdenesDeVentaGeneradas = ({ nota, setOrdenDeVenta, setOrdenes, toggleTab, canEditOV }) => {
  const fechaActual = moment().format("YYYY-MM-DD");
  const [ordenes, isLoadingOrdenes, , , fetchOrdenes] = useFetcher(getOrdenesDeVentaById, [nota.id]);
  const [categories, isLoadingCategories] = useFetcher(getNotasDePedidoCategory, undefined, "getNotasDePedidoCategory");
  const estados = categories && categories.estadoNP;
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [saveingOV, setSaveingOV] = useState(false);
  const [ov, setOv] = useState(null);

  useEffect(() => {
    if (ordenes) {
      setOrdenes(ordenes);
    }
  }, [ordenes]);

  const handleClickRow = (row) => {
    setOrdenDeVenta(row);
    toggleTab("1");
  };

  const handleClickEnviar = (row) => {
    setOv(row);
    setShowConfirmModal(true);
  };

  const handleSend = async () => {
    setSaveingOV(true);
    const { idOrdenDeVenta } = ov;
    const data = {
      estado: 2,
      fechaEnvioFacturacion: fechaActual,
    };
    try {
      await updateOrdenDeVenta(idOrdenDeVenta, data);
      toast.success("Orden de venta enviada");
      fetchOrdenes();
      setShowConfirmModal(false);
    } catch (error) {
      console.error(error);
    }

    setSaveingOV(false);
  };

  return (
    <>
      {showConfirmModal && (
        <Modal size="sm" centered isOpen={showConfirmModal}>
          <ModalBody>
            <FontAwesomeIcon icon={faWarning} className="-100" color="red" size="3x" />
            <p
              className="d-block badge-pills h-50 w-100 justify-content-center text-center py-2 mt-2"
              style={{ fontSize: "14px", fontWeight: "normal", fontFamily: "Nunito" }}
            >
              ¿Estas enviando a facturar, deseas continuar?
            </p>
          </ModalBody>
          <div className="d-flex justify-content-end m-3">
            <ModalButton className="btn px-2 py-1 text-center mr-2" onClick={() => setShowConfirmModal(false)} type="button">
              Cancelar
            </ModalButton>
            <SpinnerButtonPrimary isLoading={saveingOV} fontSize="12px" padding="5px 10px" type="button" onClick={handleSend}>
              Confirmar
            </SpinnerButtonPrimary>
          </div>
        </Modal>
      )}
      <BlurSpinner isLoading={isLoadingOrdenes || isLoadingCategories}>
        <Card className="mb-3" style={{ position: "relative", zIndex: "0" }}>
          <CardBody className="pb-3">
            <DataTable
              noDataComponent={
                <div className="p-3">
                  <b>No se encontraron ordenes de venta</b>
                </div>
              }
              onRowClicked={(row) => {
                handleClickRow(row);
              }}
              highlightOnHover
              data={ordenes.rows}
              columns={[
                {
                  name: "Orden",
                  selector: (row) => (
                    <>
                      <UncontrolledTooltip target={`orden${row.idOrdenDeVenta}`}>Copiar Nro de Orden</UncontrolledTooltip>
                      <button
                        type="button"
                        data-tag="allowRowEvents"
                        id={`orden${row.idOrdenDeVenta}`}
                        style={{ cursor: "pointer", border: "none", background: "none", outline: "none" }}
                        onClick={(event) => {
                          event.stopPropagation();
                          if (row.idOrdenDeVenta) {
                            navigator.clipboard.writeText(row.idOrdenDeVenta.toString());
                            toast.success("Nro de Orden copiado");
                          }
                        }}
                      >
                        {row.idOrdenDeVenta ? row.idOrdenDeVenta : "-"}
                      </button>
                    </>
                  ),
                  center: true,
                  width: "100px",
                },
                {
                  name: "Pedido ERP",
                  selector: (row) => row.numeroPedidoERP || "-",
                  center: true,
                  style: {
                    cursor: "pointer",
                  },
                  //   conditionalCellStyles,
                },
                {
                  name: "Fecha de envío a facturación",
                  selector: (row) => (row.fechaEnvioFacturacion ? moment(row.fechaEnvioFacturacion).format("DD/MM/YY") : "-"),
                  center: true,
                  style: {
                    cursor: "pointer",
                  },
                  //   conditionalCellStyles,
                },
                {
                  name: "Fecha factura",
                  selector: (row) => (row.fechaDeFactura ? moment(row.fechaDeFactura).format("DD/MM/YY") : "-"),
                  center: true,
                  style: {
                    cursor: "pointer",
                  },
                  //   conditionalCellStyles,
                },
                {
                  name: "Nro de factura",
                  selector: (row) => row.numeroFactura || "-",
                  center: true,
                  style: {
                    cursor: "pointer",
                  },
                  //   conditionalCellStyles,
                },
                {
                  name: "Cantidad",
                  selector: (row) => row.cantidad || "-",
                  center: true,
                  style: {
                    cursor: "pointer",
                  },
                  //   conditionalCellStyles,
                },
                {
                  name: "Importe",
                  selector: (row) => (row.total ? `$${formatNumberWithPointsAndComma(row.total)}` : "-"),
                  center: true,
                  style: {
                    cursor: "pointer",
                  },
                  //   conditionalCellStyles,
                },
                {
                  name: "Estado",
                  id: "estado",
                  selector: (row) =>
                    row.estado ? (
                      <div className="d-flex justify-content-center align-items-center my-1">
                        <div
                          data-tag="allowRowEvents"
                          className="text-center"
                          id={`estado${row.id}`}
                          style={{
                            background: `${addTransparency(getColorByStatus(row.estado), 0.2)}`,
                            color: `${getColorByStatus(row.estado)}`,
                            padding: "2px 10px",
                            borderRadius: "5px",
                            width: "100%",
                            minWidth: "80px",
                            fontSize: "12px",
                          }}
                        >
                          {getEstadoByValue(row.estado, estados && estados.ordenDeVenta)}
                        </div>
                        {row.estado === 1 && (
                          <>
                            <UncontrolledTooltip target={`facturar${row.id}`} placement="top">
                              Enviar a facturar
                              {row.observacion}
                            </UncontrolledTooltip>
                            <InvoiceButton
                              id={`facturar${row.id}`}
                              onClick={() => handleClickEnviar(row)}
                              aria-label="enviar a facturar"
                              type="button"
                              disabled={row.estado !== 1 || !canEditOV}
                              style={row.estado !== 1 ? { opacity: "0.5", cursor: "not-allowed" } : null}
                            >
                              <FontAwesomeIcon size="lg" icon="fa-solid fa-file-invoice-dollar" color="#f0292a" />
                            </InvoiceButton>
                          </>
                        )}
                      </div>
                    ) : (
                      ""
                    ),
                  width: "auto !important",
                  center: true,
                  sortable: true,
                  color: "blue",
                  wrap: true,
                  style: {
                    cursor: "pointer",
                    textAlign: "center",
                  },
                },
              ]}
            />
          </CardBody>
        </Card>
      </BlurSpinner>
    </>
  );
};

export default OrdenesDeVentaGeneradas;
